import cx from 'classnames';
import { ReactNode } from 'react';

import { SizeType } from '../types/base';
import styles from './space.module.scss';

interface Props {
  space?: SizeType;
  direction?: 'vertical' | 'horizontal';
  isFull?: boolean;
  center?: boolean;
  className?: string;
  children: ReactNode;
}

export const Space = ({ space = 'medium', direction = 'horizontal', isFull, center, className, children }: Props) => {
  return (
    <div
      className={cx(styles.wrapper, className, styles[space], styles[direction], {
        [styles.center]: center,
        [styles.isFull]: isFull,
      })}
    >
      {children}
    </div>
  );
};
